export default {"src":"/_next/static/media/thumbs-up.36bf72fa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};